import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as utils from "../../Utils/comman";
import { numberFormat } from "../../Utils/comman"; // import styles for the editor
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import "react-quill/dist/quill.snow.css";

function Pi(props) {
  const [isEdit, setisEdit] = useState(false);

  const [page, setPage] = useState(1);
  const [locations, setLocations] = useState([]);
  const countPerPage = 10;
  const [piData, setPiData] = useState([]);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1200);
  const [isTabMobile, setIsTabMobile] = useState(window.innerWidth <= 768);
  const [stateError, setStateError] = useState("");
  const dispatch = useDispatch();

  const [finalTotals, setFinalTotals] = useState({
    cgst: 0,
    sgst: 0,
    igst: 0,
    total_qty: 0,
    gross_value: 0,
    volume_disc: 0,
    qty_disc: 0,
    cash_disc: 0,
    special_disc: 0,
    net_value: 0,
    insurancePer: 0.5,
    insurance_value: 0,
    tcsPer: 0,
    tcs_value: 0,
    freight: "",
    roundOff: "",
    finalTotal: 0,
  });

  let vendorType = "";
  if (props.currentComp === "distributor") vendorType = "Distributor";
  else if (props.currentComp === "dealer") vendorType = "Dealer";
  else if (props.currentComp === "retailer") vendorType = "Retailer";
  else if (props.currentComp === "key-accounts") vendorType = "Key Accounts";
  else if (props.currentComp === "pro") vendorType = "PRO";
  const [formData, setFormData] = useState({
    invoiceNo: "Auto Generated",
    invoiceDate: new Date(),
    address: "",
    email: "",
    city: "",
    district: "",
    pinCode: "",
    paymentTerms: "",
    refNoDate: "",
    buyerOrderNo: "",
    buyerOrderDate: new Date(),
    dispatchDocNo: "",
    deliveryNoteDate: new Date(),
    dispactedThrough: "",
    destination: "",
    termsDelivery: "",
    state: "",
    deliveryNote: "",
    gstUni: "",
    officeLocation: "",
    officeName: "",
    otherRef: "",
  });

  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const [orderProducts, setOrderProducts] = useState([]);

  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  useEffect(() => {
    if (piData.order_date) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        invoiceDate: piData.order_date,
      }));
    }
  }, [piData.order_date]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let validatedValue = value;

    if (name === "mobileNo") {
      validatedValue = value.replace(/\D/g, "");
    }

    if (name === "officeLocation") {
      const selectedLocation = locations.find(
        (location) => location.id === validatedValue
      );

      setFormData({
        ...formData,
        officeLocation: validatedValue,
        address: selectedLocation ? selectedLocation.address : "",
        officeName: selectedLocation ? selectedLocation.name : "",
        email: selectedLocation ? selectedLocation.contact_person_email : "",
        city: selectedLocation ? selectedLocation.city : "",
        district: selectedLocation ? selectedLocation.district : "",
        state: selectedLocation ? selectedLocation.state : "",
        pinCode: selectedLocation ? selectedLocation.pincode : "",
        gstUni: selectedLocation ? selectedLocation.gst_uni : "",
      });

      return;
    }

    setFormData({
      ...formData,
      [name]: validatedValue,
    });
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      const piProducts = [];
      orderProducts.map((product) => {
        piProducts.push({
          id: 0,
          product_id: product.product_id,
          qty: product.qty,
          rate: product.sales_price,
          discount_per: product.volumeDisc,
          discount_per_amount: product.volumeDiscAmt,
          gross_value: product.gross_total,
          amount: product.net_total,
          cgst: product.cgst,
          cgst_amount: product.cgstAmt,
          sgst: product.sgst,
          sgst_amount: product.sgstAmt,
          igst: product.igst,
          igst_amount: product.igstAmt,
          qty_discount: product.qtyDisc,
          special_discount: product.specialDisc,
          cash_discount: product.cashDisc,
          qty_discount_amount: product.qtyDiscAmt,
          special_discount_amount: product.specialDiscAmt,
          cash_discount_amount: product.cashDiscAmt,
          total_qty: product.total_qty,
        });
      });
      const requestData = {
        order_id: props?.rowData?.id,
        created_by: userProfile?.employeeId,
        location_id: formData.officeLocation || "",
        invoice_date: moment(formData.invoiceDate).format("YYYY-MM-DD"),
        delivery_note: formData.deliveryNote || "",
        payment_terms: formData.paymentTerms || "",
        ref_no_date: formData.refNoDate || "",
        other_ref: formData.otherRef || "",
        buyers_order_no: formData.buyerOrderNo || "",
        buyers_order_date:
          moment(formData.buyerOrderDate).format("YYYY-MM-DD") || "",
        dispacth_doc_no: formData.dispatchDocNo || "",
        delivery_note_date:
          moment(formData.deliveryNoteDate).format("YYYY-MM-DD") || "",
        dispatched_through: formData.dispactedThrough || "",
        destination: formData.destination || "",
        delivery_terms: formData.termsDelivery || "",

        sub_total: finalTotals.net_value.toFixed(2),
        freight_amount: finalTotals.freight || 0,
        insurance_amount: finalTotals.insurance_value
          ? finalTotals.insurance_value.toFixed(2)
          : 0,
        insurance_per: finalTotals.insurancePer || 0,
        igst: finalTotals.igst ? finalTotals.igst.toFixed(2) : 0,
        igst_per: 0,
        sgst: finalTotals.sgst ? finalTotals.sgst.toFixed(2) : 0,
        sgst_per: 0,
        cgst: finalTotals.cgst ? finalTotals.cgst.toFixed(2) : 0,
        cgst_per: 0,
        tcs: finalTotals.tcs_value ? finalTotals.tcs_value.toFixed(2) : 0,
        tcs_per: finalTotals.tcsPer || 0,
        roundoff: finalTotals.roundOff,
        toatl_qty: finalTotals.total_qty,
        total_gross: finalTotals.gross_value,
        total_volume_discount: finalTotals.volume_disc || 0,
        total_qty_discount: finalTotals.qty_disc || 0,
        total_special_discount: finalTotals.special_disc || 0,
        total_cash_discount: finalTotals.cash_disc || 0,
        main_total: finalTotals.finalTotal.toFixed(2),
        invoice_status: "",

        products: piProducts,
      };

      utils
        .callAPI("post", "/sales/save_invoice", requestData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            setisEdit(false);
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  useEffect(() => {
    setFormData({
      ...formData,
      officeLocation: props?.rowData?.location_id,
      buyerOrderDate:
        props?.rowData?.po_date != "" ? props?.rowData?.po_date : new Date(),
      buyerOrderNo: props?.rowData?.po_no != "" ? props?.rowData?.po_no : "",
    });
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1200);
      setIsTabMobile(window.innerWidth < 768); // Adjust the width as per your tablet/mobile breakpoint
    };

    // Initial call to set the initial state
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getOrderList();
  }, []);

  useEffect(() => {
    getLocationList();
  }, []);

  useEffect(() => {
    calculateFinalTotals();
  }, [orderProducts]);

  const getLocationList = () => {
    var bodyFormData = new FormData();

    //  bodyFormData.append("id", props?.rowData?.id);
    bodyFormData.append("page", page);
    bodyFormData.append("per_page", countPerPage);

    utils
      .callAPI("get", `/sales/getLocationList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setLocations(res.result);
        } else {
          setLocations([]);
        }
      })
      .catch((err) => {
        setLocations([]);
      });
  };

  const getOrderList = () => {
    var bodyFormData = new FormData();

    bodyFormData.append("order_by", "");
    bodyFormData.append("id", props?.rowData?.id);
    bodyFormData.append("page", page);
    bodyFormData.append("per_page", countPerPage);

    utils
      .callAPI("post", `/sales/getOrdersList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          const products = [...res.result[0]?.product];

          products.map((product) => {
            product.cgst = "";
            product.cgstAmt = 0;
            product.isCgst = true;
            product.sgst = "";
            product.sgstAmt = 0;
            product.isSgst = true;
            product.igst = "";
            product.igstAmt = 0;
            product.isIgst = true;
            product.volumeDisc = "";
            product.volumeDiscAmt = 0;
            product.qtyDisc = "";
            product.qtyDiscAmt = 0;
            product.cashDisc = "";
            product.cashDiscAmt = 0;
            product.specialDisc = "";
            product.specialDiscAmt = 0;
            product.total_qty = (
              parseInt(product.qty) * parseInt(product.size)
            ).toFixed(2);
            product.gross_total =
              parseInt(product.qty) * parseInt(product.sales_price);
            product.net_total = calculateDiscount(product).net_total;
          });

          setOrderProducts(products);
          setPiData(res.result[0]);
        } else {
          setPiData([]);
        }
      })
      .catch((err) => {
        setPiData([]);
      });
  };

  useEffect(() => {
    if (formData.officeLocation && locations.length > 0) {
      setAdditionalFields(formData.officeLocation);
    }
  }, [formData.officeLocation, locations]);

  const setAdditionalFields = (locationId) => {
    const selectedLocation = locations.find(
      (location) => location.id === locationId
    );

    setFormData({
      ...formData,
      address: selectedLocation ? selectedLocation.address : "",
      officeName: selectedLocation ? selectedLocation.name : "",
      email: selectedLocation ? selectedLocation.contact_person_email : "",
      city: selectedLocation ? selectedLocation.city : "",
      district: selectedLocation ? selectedLocation.district : "",
      state: selectedLocation ? selectedLocation.state : "",
      pincode: selectedLocation ? selectedLocation.pincode : "",
      gstUni: selectedLocation ? selectedLocation.gst_uni : "",
    });
  };

  const handleProductInputChange = (target, index) => {
    const { value, name } = target.target;
    const products = [...orderProducts];
    products[index][name] = value;

    if (name === "qty") {
      const qtyValue = value > 0 ? value : 0;
      const product = products[index];
      products[index].total_qty = (parseInt(product.size) * qtyValue).toFixed(
        2
      );
      products[index].gross_total = parseInt(product.sales_price) * qtyValue;

      products[index] = calculateDiscount(products[index]);
    }

    if (
      name === "volumeDisc" ||
      name === "qtyDisc" ||
      name === "cashDisc" ||
      name === "specialDisc"
    ) {
      products[index] = calculateDiscount(products[index]);
    }

    // if(name === "cgst" || name === 'sgst' || name === 'igst') {
    products[index] = calculateGST(products[index]);
    // }

    setOrderProducts(products);
  };

  const calculateGST = (product) => {
    const isCgst = product.cgst > 0;
    const isSgst = product.sgst > 0;
    const isIgst = product.igst > 0;

    product.isCgst = true;
    product.isSgst = true;
    product.isIgst = true;
    const netTotal = product.net_total;
    product.cgstAmt = 0;
    product.sgstAmt = 0;
    product.igstAmt = 0;
    if (isCgst || isSgst) {
      product.isCgst = true;
      product.isSgst = true;
      product.isIgst = false;
      const cgst = parseFloat(product.cgst);
      const sgst = parseFloat(product.sgst);
      product.cgstAmt = cgst > 0 ? netTotal * (cgst / 100) : 0;
      product.sgstAmt = sgst > 0 ? netTotal * (sgst / 100) : 0;
      product.igstAmt = 0;
    }

    if (isIgst) {
      product.isCgst = false;
      product.isSgst = false;
      product.isIgst = true;

      const igst = parseFloat(product.igst);
      product.cgstAmt = 0;
      product.sgstAmt = 0;
      product.igstAmt = igst > 0 ? netTotal * (igst / 100) : 0;
    }

    return product;
  };

  const calculateDiscount = (product) => {
    let grossTotal = product.gross_total ?? 0;
    const volumeDiscountPer = parseFloat(product.volumeDisc ?? 0);
    const qtyDiscountPer = parseFloat(product.qtyDisc ?? 0);
    const cashDiscountPer = parseFloat(product.cashDisc ?? 0);
    const specialDiscountPer = parseFloat(product.specialDisc ?? 0);

    let qtyDisc = 0;
    let cashDisc = 0;
    let specialDisc = 0;
    let volumeDisc = 0;
    if (volumeDiscountPer) {
      volumeDisc = grossTotal * (volumeDiscountPer / 100);
      grossTotal -= volumeDisc;
    }

    if (qtyDiscountPer) {
      qtyDisc = grossTotal * (qtyDiscountPer / 100);
      grossTotal -= qtyDisc;
    }

    if (cashDiscountPer) {
      cashDisc = grossTotal * (cashDiscountPer / 100);
      grossTotal -= cashDisc;
    }

    if (specialDiscountPer) {
      specialDisc = grossTotal * (specialDiscountPer / 100);
      grossTotal -= specialDisc;
    }

    product.volumeDiscAmt = volumeDisc;
    product.qtyDiscAmt = qtyDisc;
    product.cashDiscAmt = cashDisc;
    product.specialDiscAmt = specialDisc;
    product.net_total = grossTotal;
    return product;
  };

  const updateTaxWithInsuranceAndFreight = (
    taxType,
    insuranceShare,
    freightShare
  ) => {
    if (taxType > 0) {
      taxType += insuranceShare + freightShare;
    }
    return taxType;
  };

  const calculateTaxAndInsuranceWithFreight = (finalTotal) => {
    const cgstTax = finalTotal.cgst;
    const sgstTax = finalTotal.sgst;
    const igstTax = finalTotal.igst;
    const freightAmount = finalTotal.freight >= 0.0 ? finalTotal.freight : 0;

    const taxableAmount = finalTotal.net_value;

    const insuranceShare = finalTotal.insurance_value;

    const insuranceCgst = insuranceShare * (cgstTax / taxableAmount);
    const insuranceSgst = insuranceShare * (sgstTax / taxableAmount);
    const insuranceIgst = insuranceShare * (igstTax / taxableAmount);

    const freightCgst = freightAmount * (cgstTax / taxableAmount);
    const freightSgst = freightAmount * (sgstTax / taxableAmount);
    const freightIgst = freightAmount * (igstTax / taxableAmount);

    finalTotal.cgst = updateTaxWithInsuranceAndFreight(
      finalTotal.cgst,
      insuranceCgst,
      freightCgst
    );
    finalTotal.sgst = updateTaxWithInsuranceAndFreight(
      finalTotal.sgst,
      insuranceSgst,
      freightSgst
    );
    finalTotal.igst = updateTaxWithInsuranceAndFreight(
      finalTotal.igst,
      insuranceIgst,
      freightIgst
    );

    return finalTotal;
  };

  const calculateFinalTotals = () => {
    let finalTotal = {
      cgst: 0,
      sgst: 0,
      igst: 0,
      total_qty: 0,
      gross_value: 0,
      volume_disc: 0,
      qty_disc: 0,
      cash_disc: 0,
      special_disc: 0,
      net_value: 0,
      insurancePer: 0,
      insurance_value: 0,
      tcsPer: 0,
      tcs_value: 0,
      freight: "",
      roundOff: "",
      finalTotal: 0,
    };

    orderProducts.map((product) => {
      finalTotal.cgst += parseFloat(product.cgstAmt);
      finalTotal.sgst += parseFloat(product.sgstAmt);
      finalTotal.igst += parseFloat(product.igstAmt);
      finalTotal.total_qty += parseFloat(product.total_qty);
      finalTotal.gross_value += product.gross_total;
      finalTotal.volume_disc += product.volumeDiscAmt;
      finalTotal.qty_disc += product.qtyDiscAmt;
      finalTotal.cash_disc += product.cashDiscAmt;
      finalTotal.special_disc += product.specialDiscAmt;
      finalTotal.net_value += product.net_total;
    });

    const insurancePer =
      finalTotals.insurancePer >= 0.0 ? finalTotals.insurancePer : "";
    finalTotal.insurancePer = insurancePer;
    if (insurancePer > 0) {
      finalTotal.insurance_value = finalTotal.net_value * (insurancePer / 100);
    }

    finalTotal.freight = finalTotals.freight >= 0.0 ? finalTotals.freight : "";

    finalTotal = calculateTaxAndInsuranceWithFreight(finalTotal);

    const tcsPer = finalTotals.tcsPer >= 0.0 ? finalTotals.tcsPer : "";

    finalTotal.tcsPer = tcsPer;
    const tcsBase =
      finalTotal.net_value +
      finalTotal.insurance_value +
      parseFloat(finalTotal.freight || 0) +
      finalTotal.cgst +
      finalTotal.sgst +
      finalTotal.igst;

    if (tcsPer > 0) {
      finalTotal.tcs_value = tcsBase * (tcsPer / 100);
    }

    finalTotal = calculateRodOffValue(finalTotal);

    finalTotal.finalTotal =
      parseFloat(finalTotal.net_value) +
      parseFloat(finalTotal.insurance_value) +
      parseFloat(finalTotal.freight ? finalTotal.freight : 0) +
      parseFloat(finalTotal.cgst) +
      parseFloat(finalTotal.sgst) +
      parseFloat(finalTotal.igst) +
      parseFloat(finalTotal.tcs_value ? finalTotal.tcs_value : 0);

    setFinalTotals(finalTotal);
  };

  const calculateRodOffValue = (finalTotal) => {
    const totalValue = finalTotal.finalTotal;
    const intPart = Math.floor(totalValue);
    const decimalPart = totalValue - intPart;

    // Determine the rounded total
    const roundedTotal =
      decimalPart >= 0.5 ? Math.ceil(totalValue) : Math.floor(totalValue);

    // Calculate adjustment and determine the sign
    const adjustment = roundedTotal - totalValue;
    const sign = adjustment > 0 ? "+" : adjustment < 0 ? "-" : "";

    // Update the finalTotal object
    finalTotal.finalTotal = roundedTotal;
    finalTotal.roundOff = sign
      ? `(${sign}) ${Math.abs(adjustment).toFixed(2)}`
      : `${adjustment.toFixed(2)}`;

    return finalTotal;
  };

  const handleFinalTotalInputChange = (e) => {
    const { name, value } = e.target;
    const finalTotal = finalTotals;

    finalTotal[name] = value;
    setFinalTotals(finalTotal);

    calculateFinalTotals();
  };

  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          {/* <h4>{isEdit ? `Edit ${vendorType}` : `Pi ${vendorType}`}</h4> */}
          <h4>{isEdit ? "Edit" : "Create"} Proforma Invoice</h4>
          <div className="card-header-action">
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row className={"border"}>
              <RB.Col md={12} className={"py-2 text-center"}>
                <h6 className={"mb-0"}>PROFORMA INVOICE</h6>
              </RB.Col>
            </RB.Row>

            <RB.Row className={"border border-top-0"}>
              <RB.Col md={4} className={"border-end py-2"}>
                <h6>
                  <strong>Supplier - Seller:</strong>
                </h6>
                <p className={"mb-0"}>
                  <strong>{piData.registered_office?.company_name}</strong>
                </p>
                <p className={"mb-0"}>
                  {piData.registered_office?.address}
                  <br />
                  {piData.registered_office?.city} -{" "}
                  {piData.registered_office?.pincode}
                </p>
                <p className={"mb-0"}>
                  <strong>State:</strong> {piData.registered_office?.state}
                </p>
                <RB.Row>
                  <RB.Col md={6}>
                    <strong>GSTIN:</strong> {piData.registered_office?.gstno}
                  </RB.Col>
                  <RB.Col md={6}>{/*<strong>PAN:</strong> AABCS4338M*/}</RB.Col>
                </RB.Row>

                {/*<RB.Row>
                  <RB.Col md={6}>
                    <strong>CIN:</strong> U26109TN1997PL037875
                  </RB.Col>
                  <RB.Col md={6}>
                    <strong>TAN:</strong> CHES05530A
                  </RB.Col>
                </RB.Row>*/}
              </RB.Col>
              <RB.Col md={4} className={"border-end py-2"}>
                <h6>
                  <strong>Recipient - Customer :</strong>
                </h6>
                {piData?.channel_details?.company_address ? (
                  <>
                    <p className={"mb-0"}>
                      <strong>{piData?.channel_details?.companyName}</strong>
                    </p>
                    <p className={"mb-0"}>
                      {piData?.channel_details?.company_address},<br />
                      {piData?.channel_details?.company_district},<br />
                      {piData?.channel_details?.company_city} -{" "}
                      {piData?.channel_details?.company_pincode},<br />
                      Ph. : {piData?.channel_details?.contactNo}
                      <br />
                    </p>
                    <p className={"mb-0"}>
                      <strong>State:</strong>{" "}
                      {piData?.channel_details?.company_state}
                    </p>
                    <p className={"mb-0"}>
                      <strong>GSTIN:</strong> {piData?.channel_details?.gst_no}
                    </p>
                  </>
                ) : (
                  ""
                )}
              </RB.Col>
              <RB.Col md={4} className={"border1 py-2"}>
                <p className={"mb-0"}>
                  <strong>Proforma Invoice No.: </strong> AUTO GENERATE
                </p>
                <RB.Row className={"align-items-center"}>
                  <RB.Col md={"auto"}>
                    <strong>PI Date: </strong>
                  </RB.Col>
                  <RB.Col>
                    <DatePicker
                      selected={formData.invoiceDate}
                      onChange={(date) =>
                        setFormData({ ...formData, invoiceDate: date })
                      }
                      dateFormat="dd-MM-yyyy"
                      className="form-control form-control-sm"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  </RB.Col>
                </RB.Row>
                <p className={"mb-0"}>
                  <strong>Sales Order No.: </strong> {piData?.order_id}
                </p>
                <p className={"mb-0"}>
                  <strong>Sales Order Date: </strong>{" "}
                  {moment(piData?.order_date).format("DD-MM-YYYY")}
                </p>
                <p className={"mb-0"}>
                  <strong>Ref.: </strong> {piData?.emp_ref_no}
                </p>
              </RB.Col>
            </RB.Row>
            <RB.Row className={"border border-top-0"}>
              <RB.Col md={4} className={"border-end py-2"}>
                <RB.Row className={"align-items-center"}>
                  <RB.Col md={"auto"}>
                    <h6>
                      <strong>Destination Center:</strong>
                    </h6>
                  </RB.Col>
                  <RB.Col>
                    <RB.Form.Select
                      size={"sm"}
                      name="officeLocation"
                      className="form-control form-select"
                      value={formData.officeLocation}
                      onChange={handleInputChange}
                      required
                    >
                      <option value=""> Destination Center...</option>
                      {locations?.map((location, index) => (
                        <option key={index} value={location.id}>
                          {location.name}
                        </option>
                      ))}
                    </RB.Form.Select>
                    {stateError && (
                      <span className="text-danger">{stateError}</span>
                    )}
                  </RB.Col>
                </RB.Row>
                {formData.address ? (
                  <>
                    <p className={"mb-0"}>
                      <strong>{formData?.officeName}</strong>
                    </p>
                    <p className={"mb-0"}>
                      {formData?.address},<br />
                      {formData?.city},<br />
                      {formData.state} - {formData.pinCode}
                    </p>
                  </>
                ) : (
                  ""
                )}
              </RB.Col>
              <RB.Col md={4} className={"border-end py-2"}>
                <h6>
                  <strong>Ship - To :</strong>
                </h6>
                {piData?.channel_details?.company_address ? (
                  <>
                    <p className={"mb-0"}>
                      <strong>{piData?.channel_details?.companyName}</strong>
                    </p>
                    <p className={"mb-0"}>
                      {piData?.channel_details?.company_address},<br />
                      {piData?.channel_details?.company_district},<br />
                      {piData?.channel_details?.company_city} -{" "}
                      {piData?.channel_details?.company_pincode},<br />
                      Ph. : {piData?.channel_details?.contactNo}
                      <br />
                    </p>
                    <p className={"mb-0"}>
                      <strong>State:</strong>{" "}
                      {piData?.channel_details?.company_state}
                    </p>
                    <p className={"mb-0"}>
                      <strong>GSTIN:</strong> {piData?.channel_details?.gst_no}
                    </p>
                  </>
                ) : (
                  ""
                )}
              </RB.Col>
              <RB.Col md={4} className={"border1 py-2"}></RB.Col>
            </RB.Row>

            <RB.Row className={"border border-top-0"}>
              <RB.Col md={4}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Delivery Note"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Delivery Note "
                      name="deliveryNote"
                      value={formData.deliveryNote}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={4}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Payment Terms"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="select"
                      name="paymentTerms"
                      value={formData.paymentTerms}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Payment Terms...</option>
                      <option value="Advance Payment">Advance Payment</option>
                      <option value="07 Days">07 Days</option>
                      <option value="15 Days">15 Days</option>
                      <option value="30 Days">30 Days</option>
                      <option value="45 Days">45 Days</option>
                      <option value="60 Days">60 Days</option>
                      <option value="90 Days">90 Days</option>
                    </RB.Form.Control>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={4}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Reference No. & Date."
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Reference No. & Date. "
                      name="refNoDate"
                      value={formData.refNoDate}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={4}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Other References"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Other References"
                      name="otherRef"
                      value={formData.otherRef}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={4}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Buyer’s Order No."
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Buyer's Order No "
                      name="buyerOrderNo"
                      value={formData.buyerOrderNo}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={4}>
                <div className="mb-3 mt-3">
                  <RB.FloatingLabel
                    label="Buyer's Order Date"
                    className={`floating-label-fancy ${"dateSelected"}`}
                  >
                    <DatePicker
                      selected={formData.buyerOrderDate}
                      onChange={(date) =>
                        setFormData({ ...formData, buyerOrderDate: date })
                      }
                      dateFormat="dd-MM-yyyy"
                      className="form-control"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      //  placeholderText="Buyer's Order Date"
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={4}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Dispatch Doc No."
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      // placeholder="Enter Buyer'sOrder Date "
                      name="dispatchDocNo"
                      value={formData.dispatchDocNo}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={4}>
                <div className="mb-3 mt-3">
                  <RB.FloatingLabel
                    label="Delivery Note Date"
                    className={`floating-label-fancy ${"dateSelected"}`}
                  >
                    <DatePicker
                      selected={formData.deliveryNoteDate}
                      onChange={(date) =>
                        setFormData({ ...formData, deliveryNoteDate: date })
                      }
                      dateFormat="dd-MM-yyyy"
                      className="form-control"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      //placeholderText="Delivery Note Date"
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={4}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Dispatched through"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      // placeholder="Enter Buyer'sOrder Date "
                      name="dispactedThrough"
                      value={formData.dispactedThrough}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={4}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Destination"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      // placeholder="Enter Buyer'sOrder Date "
                      name="destination"
                      value={formData.destination}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={8}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Terms of Delivery"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="textarea"
                      type="text"
                      placeholder="Enter Terms of Delivery"
                      name="termsDelivery"
                      value={formData.termsDelivery}
                      onChange={handleInputChange}
                      maxLength={1000}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <RB.Row className={"border border-bottom-0"}>
              <h5 className="mt-3">Products </h5>

              <div className={"table-responsive p-0 border"}>
                <RB.Table
                  bordered
                  hover
                  striped
                  className="border mb-0 table-sm table-invoice-products"
                >
                  <thead>
                    <tr>
                      <th rowSpan={2}>S.No</th>
                      <th rowSpan={2}>Description of Goods</th>
                      <th className={"text-center"} rowSpan={2}>
                        UOM
                      </th>
                      <th className={"text-center"} rowSpan={2}>
                        HSN
                      </th>
                      <th className={"text-center"}>CGST</th>
                      <th className={"text-center"}>SGST</th>
                      <th className={"text-center"}>IGST</th>
                      <th className={"text-center"} rowSpan={2}>
                        Rate / UOM
                      </th>
                      <th colSpan={3} className={"text-center"}>
                        Quantity
                      </th>
                      <th className={"text-center"} rowSpan={2}>
                        Gross Value
                      </th>
                      <th className={"text-center"} colSpan={4}>
                        Discounts
                      </th>
                      <th className={"text-center"} rowSpan={2}>
                        Net Value
                      </th>
                    </tr>
                    <tr>
                      <th className={"text-center"}>%</th>
                      <th className={"text-center"}>%</th>
                      <th className={"text-center"}>%</th>
                      <th className={"text-center"}>In UOM</th>
                      <th className={"text-center"}>Pack Size</th>
                      <th className={"text-center"}>Total Qty(Kg)</th>
                      <th className={"text-center"}>Trade (%)</th>
                      <th className={"text-center"}>Quantity (%)</th>
                      <th className={"text-center"}>Cash (%)</th>
                      <th className={"text-center"}>Special (%)</th>
                    </tr>
                  </thead>

                  <tbody>
                    {orderProducts.length &&
                      orderProducts.map((product, index) => (
                        <tr key={index}>
                          <td className={"text-center"}>{index + 1}</td>
                          <td>{product.product_name}</td>
                          <td className={"text-center"}>
                            {(product.mou || "").toUpperCase()}
                          </td>
                          <td className={"text-center"}>
                            {product.hsn_code || ""}
                          </td>
                          <td className={"text-end"}>
                            <RB.Form.Control
                              size={"sm"}
                              type="text"
                              placeholder="CGST"
                              name="cgst"
                              value={product.cgst}
                              disabled={!product.isCgst}
                              onChange={(e) =>
                                handleProductInputChange(e, index)
                              }
                            />
                          </td>
                          <td className={"text-end"}>
                            <RB.Form.Control
                              size={"sm"}
                              type="text"
                              placeholder="SGST"
                              name="sgst"
                              value={product.sgst}
                              disabled={!product.isSgst}
                              onChange={(e) =>
                                handleProductInputChange(e, index)
                              }
                            />
                          </td>
                          <td className={"text-end"}>
                            <RB.Form.Control
                              size={"sm"}
                              type="text"
                              placeholder="IGST"
                              name="igst"
                              value={product.igst}
                              disabled={!product.isIgst}
                              onChange={(e) =>
                                handleProductInputChange(e, index)
                              }
                            />
                          </td>
                          <td className={"text-end"}>
                            {numberFormat(product.sales_price)}
                          </td>
                          <td className={"text-end"}>
                            <RB.Form.Control
                              size={"sm"}
                              type="text"
                              placeholder="Qty"
                              name="qty"
                              value={product.qty}
                              onChange={(e) =>
                                handleProductInputChange(e, index)
                              }
                            />
                          </td>
                          <td className={"text-end"}>
                            {parseInt(product.size).toFixed(2)}
                          </td>
                          <td className={"text-end"}>{product.total_qty}</td>
                          <td className={"text-end"}>
                            {numberFormat(product.gross_total)}
                          </td>
                          <td className={"text-end"}>
                            <RB.Form.Control
                              size={"sm"}
                              type="text"
                              placeholder="Trade Disc."
                              name="volumeDisc"
                              value={product.volumeDisc}
                              onChange={(e) =>
                                handleProductInputChange(e, index)
                              }
                            />
                          </td>
                          <td className={"text-end"}>
                            <RB.Form.Control
                              size={"sm"}
                              type="text"
                              placeholder="Quantity Disc."
                              name="qtyDisc"
                              value={product.qtyDisc}
                              onChange={(e) =>
                                handleProductInputChange(e, index)
                              }
                            />
                          </td>
                          <td className={"text-end"}>
                            <RB.Form.Control
                              size={"sm"}
                              type="text"
                              placeholder="Cash Disc."
                              name="cashDisc"
                              value={product.cashDisc}
                              onChange={(e) =>
                                handleProductInputChange(e, index)
                              }
                            />
                          </td>
                          <td className={"text-end"}>
                            <RB.Form.Control
                              size={"sm"}
                              type="text"
                              placeholder="Special Disc."
                              name="specialDisc"
                              value={product.specialDisc}
                              onChange={(e) =>
                                handleProductInputChange(e, index)
                              }
                            />
                          </td>
                          <td className={"text-end"}>
                            {numberFormat(product.net_total)}
                          </td>
                        </tr>
                      ))}
                  </tbody>

                  <tfoot>
                    <tr>
                      <th colSpan={9}></th>
                      <th className={"text-end"}>Total</th>
                      <th className={"text-end"}>
                        {finalTotals.total_qty.toFixed(2)}
                      </th>
                      <th className={"text-end"}>
                        {numberFormat(finalTotals.gross_value)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(finalTotals.volume_disc)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(finalTotals.qty_disc)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(finalTotals.cash_disc)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(finalTotals.special_disc)}
                      </th>
                      <th className={"text-end"}>
                        {numberFormat(finalTotals.net_value)}
                      </th>
                    </tr>
                  </tfoot>
                </RB.Table>
              </div>
            </RB.Row>

            <RB.Row>
              <RB.Col>
                <RB.Row
                  className={"border border-top-0 align-items-center py-3"}
                >
                  <RB.Col md={8} className={"text-end"}>
                    Net Amount
                  </RB.Col>
                  <RB.Col md={2}></RB.Col>
                  <RB.Col md={2} className={"text-end"}>
                    <strong>{numberFormat(finalTotals.net_value)}</strong>
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"border border-top-0 align-items-center"}>
                  <RB.Col md={8} className={"text-end"}>
                    Insurance (%)
                  </RB.Col>
                  <RB.Col md={2}>
                    <RB.FloatingLabel
                      // label="Insurance"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        size={"sm"}
                        type="text"
                        placeholder="Insurance"
                        name="insurancePer"
                        className={"mb-2"}
                        value={finalTotals.insurancePer}
                        onChange={handleFinalTotalInputChange}
                      />
                    </RB.FloatingLabel>
                  </RB.Col>
                  <RB.Col md={2} className={"text-end"}>
                    <strong>
                      {numberFormat(
                        finalTotals.insurance_value > 0
                          ? finalTotals.insurance_value
                          : 0
                      )}
                    </strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border border-top-0 align-items-center"}>
                  <RB.Col md={8} className={"text-end"}>
                    Freight Amount (₹)
                  </RB.Col>
                  <RB.Col md={2}>
                    <RB.FloatingLabel
                      // label="Freight"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        size={"sm"}
                        type="text"
                        placeholder="Freight"
                        name="freight"
                        className={"mb-2"}
                        value={finalTotals.freight}
                        onChange={handleFinalTotalInputChange}
                      />
                    </RB.FloatingLabel>
                  </RB.Col>
                  <RB.Col md={2} className={"text-end"}>
                    <strong>
                      {numberFormat(
                        finalTotals.freight > 0 ? finalTotals.freight : 0
                      )}
                    </strong>
                  </RB.Col>
                </RB.Row>

                <RB.Row
                  className={"border border-top-0 align-items-center py-3"}
                >
                  <RB.Col md={8} className={"text-end"}>
                    CGST
                  </RB.Col>
                  <RB.Col md={2}></RB.Col>
                  <RB.Col md={2} className={"text-end"}>
                    <strong>{numberFormat(finalTotals.cgst)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row
                  className={"border border-top-0 align-items-center py-3"}
                >
                  <RB.Col md={8} className={"text-end"}>
                    SGST
                  </RB.Col>
                  <RB.Col md={2}></RB.Col>
                  <RB.Col md={2} className={"text-end"}>
                    <strong>{numberFormat(finalTotals.sgst)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row
                  className={"border border-top-0 align-items-center py-3"}
                >
                  <RB.Col md={8} className={"text-end"}>
                    IGST
                  </RB.Col>
                  <RB.Col md={2}></RB.Col>
                  <RB.Col md={2} className={"text-end"}>
                    <strong>{numberFormat(finalTotals.igst)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border border-top-0 align-items-center"}>
                  <RB.Col md={8} className={"text-end"}>
                    TCS (%)
                  </RB.Col>

                  <RB.Col md={2}>
                    <RB.FloatingLabel
                      // label="TCS"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        size={"sm"}
                        type="text"
                        placeholder="TCS"
                        name="tcsPer"
                        className={"mb-2"}
                        value={finalTotals.tcsPer}
                        onChange={handleFinalTotalInputChange}
                      />
                    </RB.FloatingLabel>
                  </RB.Col>
                  <RB.Col md={2} className={"text-end"}>
                    <strong>
                      {numberFormat(
                        finalTotals.tcs_value > 0 ? finalTotals.tcs_value : 0
                      )}
                    </strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row
                  className={"border border-top-0 align-items-center py-3"}
                >
                  <RB.Col md={8} className={"text-end"}>
                    Round Off
                  </RB.Col>
                  <RB.Col md={2}></RB.Col>
                  <RB.Col md={2} className={"text-end"}>
                    <strong>{finalTotals.roundOff}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row
                  className={
                    "border border-top-0 align-items-center py-3 bg-light"
                  }
                >
                  <RB.Col md={8} className={"text-end"}>
                    <strong>Invoice Total</strong>
                  </RB.Col>
                  <RB.Col md={2}></RB.Col>
                  <RB.Col md={2} className={"text-end"}>
                    <strong>{numberFormat(finalTotals.finalTotal)}</strong>
                  </RB.Col>
                </RB.Row>
              </RB.Col>
            </RB.Row>

            <RB.Row className="align-items-center mt-3">
              <RB.Col className="col-auto">
                <RB.Button variant="primary" type="submit">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Pi;
